export const speedFeatures = [
  {
    title: "초고속 로딩",
    description: "3초 이내에 경기 화면이 나타나는 초고속 스트리밍 시스템으로 끊김 없는 시청을 보장합니다.",
    icon: "ri-flashlight-line",
  },
  {
    title: "저지연 전송",
    description: "전 세계 서버 네트워크를 통해 실제 경기와 1초 미만의 지연 시간으로 실시간 중계를 제공합니다.",
    icon: "ri-timer-flash-line",
  },
  {
    title: "자동 화질 조절",
    description: "네트워크 상황에 따라 실시간으로 화질을 최적화하여 버퍼링 없이 시청 가능합니다.",
    icon: "ri-signal-wifi-line",
  },
  {
    title: "멀티 디바이스",
    description: "PC, 스마트폰, 태블릿 어디서나 동일한 속도로 중계를 시청할 수 있습니다.",
    icon: "ri-smartphone-line",
  },
];

export const speedSportsChannels = [
  { name: "스피드 축구 중계", league: "해외축구", quality: "1080p 60fps", delay: "0.5초" },
  { name: "스피드 MLB 중계", league: "MLB", quality: "1080p 60fps", delay: "0.8초" },
  { name: "스피드 NBA 중계", league: "NBA", quality: "1080p 60fps", delay: "0.6초" },
  { name: "스피드 KBO 중계", league: "KBO", quality: "1080p 60fps", delay: "0.5초" },
  { name: "스피드 KBL 중계", league: "KBL", quality: "1080p 60fps", delay: "0.7초" },
  { name: "스피드 V리그 중계", league: "V리그", quality: "1080p 60fps", delay: "0.6초" },
];